module.exports = __webpack_public_path__ + "img/frame (40).015df7de.jpg";